import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./index.scss";

/**
 * @param {Array} fields - Liste des champs [{ name: "category", label: "Category", placeholder: "Search category..." }]
 * @param {Function} onApply - Callback appelé avec { [fieldName]: value }
 */
const FilterDropdown = ({ fields, onApply }) => {
  const [values, setValues] = useState({});

  const handleChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleApply = () => {
    onApply(values);
  };

  return (
    <div className="filter-dropdown shadow p-3">
      {fields.map((field) => (
        <Form.Group className="mb-3" key={field.name}>
          <Form.Label>{field.label}</Form.Label>
          <Form.Control
            type="text"
            placeholder={
              field.placeholder || `Search ${field.label.toLowerCase()}...`
            }
            value={values[field.name] || ""}
            onChange={(e) => handleChange(field.name, e.target.value)}
          />
        </Form.Group>
      ))}

      <Button className="btn-apply w-100" onClick={handleApply}>
        Apply
      </Button>
    </div>
  );
};

export default FilterDropdown;
